module.exports = __webpack_public_path__ + "img/logo-eureciclo-rodape.e31ce537.png";